import { useRef, cloneElement } from 'react';
import { CSSTransition } from 'react-transition-group';

const SlideTransition = ({ inProp, children, timeout = 300, direction = 'down' }) => {
    const nodeRef = useRef(null);
    return (
        <CSSTransition in={inProp} timeout={timeout} classNames={`slide-${direction}`} unmountOnExit nodeRef={nodeRef}>
            {cloneElement(children, { ref: nodeRef })}
        </CSSTransition>
    );
};

export default SlideTransition;
